module.exports = __webpack_public_path__ + "img/calendar3.b4d56a5a.svg";